const siteLanguageList = [
  {
    code: 'en',
    name: 'English (English)',
    released: true,
  },
  {
    code: 'ar',
    name: 'العربية (Arabic)',
    released: true,
  },
  {
    code: 'ca',
    name: 'Català (Catalan)',
    released: false,
  },
  {
    code: 'es-419',
    name: 'Español (Latinoamérica) (Spanish)',
    released: true,
  },
  {
    code: 'fa-ir',
    name: 'فارسی (Persian)',
    released: true,
  },
  {
    code: 'fr',
    name: 'Français (French)',
    released: true,
  },
  {
    code: 'he',
    name: 'עברית (Hebrew)',
    released: false,
  },
  {
    code: 'id',
    name: 'Bahasa Indonesia (Indonesian)',
    released: false,
  },
  {
    code: 'ko-kr',
    name: '한국어 (대한민국) (Korean)',
    released: false,
  },
  {
    code: 'pl',
    name: 'Polski (Polish)',
    released: false,
  },
  {
    code: 'pt-br',
    name: 'Português (Brasil) (Portuguese - Brazil)',
    released: false,
  },
  {
    code: 'ru',
    name: 'Русский (Russian)',
    released: false,
  },
  {
    code: 'th',
    name: 'ไทย (Thai)',
    released: false,
  },
  {
    code: 'uk',
    name: 'Українська (Ukrainian)',
    released: false,
  },
  {
    code: 'zh-cn',
    name: '中文 (简体) (Chinese - Simplified)',
    released: true,
  },
  {
    code: 'pt-pt',
    name: 'Português (Portuguese)',
    released: true,
  },
  {
    code: 'it-it',
    name: 'Italiano (Italian)',
    released: true,
  },
  {
    code: 'de-de',
    name: 'Deutsch (German)',
    released: true,
  },
  {
    code: 'hi',
    name: 'हिन्दी (Hindi)',
    released: true,
  },
  {
    code: 'fr-ca',
    name: 'Français (CA) (French - Canada)',
    released: true,
  },
  {
    code: 'te',
    name: 'తెలుగు (Telugu)',
    released: true,
  },
  {
    code: 'da',
    name: 'dansk (Danish)',
    released: true,
  },
  {
    code: 'el',
    name: 'Ελληνικά (Greek)',
    released: true,
  },
  {
    code: 'es-es',
    name: 'Español (España) (Spanish - Spain)',
    released: true,
  },
  {
    code: 'sw',
    name: 'Kiswahili (Swahili)',
    released: true,
  },
  {
    code: 'tr-tr',
    name: 'Türkçe (Türkiye) (Turkish)',
    released: true,
  },
  {
    code: 'bn',
    name: 'বাংলা (Bengali)',
    released: false,
  },
  {
    code: 'mr',
    name: 'मराठी (Marathi)',
    released: false,
  },
  {
    code: 'ta',
    name: 'தமிழ் (Tamil)',
    released: false,
  },
  {
    code: 'gu',
    name: 'ગુજરાતી (Gujarati)',
    released: false,
  },
  {
    code: 'kn',
    name: 'ಕನ್ನಡ (Kannada)',
    released: false,
  },
  {
    code: 'ml',
    name: 'മലയാളം (Malayalam)',
    released: false,
  },
  {
    code: 'pa',
    name: 'ਪੰਜਾਬੀ (Punjabi)',
    released: false,
  },
  {
    code: 'or',
    name: 'ଓଡ଼ିଆ (Odia)',
    released: false,
  },
  {
    code: 'ur',
    name: 'اردو (Urdu)',
    released: false,
  },
  {
    code: 'sa',
    name: 'संस्कृत (Sanskrit)',
    released: false,
  },
  {
    code: 'ne',
    name: 'नेपाली (Nepali)',
    released: false,
  },
  {
    code: 'sd',
    name: 'سنڌي (Sindhi)',
    released: false,
  }
];

export default siteLanguageList;
